export default "__VITE_ASSET__b908228c__"